/*
IMPORTANT: After modifying this file, update CHANGELOG.md with a summary of your changes.
Add clear comments for non-obvious changes, including what replaced prior behavior, to avoid repeating failed fixes.
*/

// The markup half of the honeypot. Shared by every public form so the site
// presents ONE decoy to a crawler rather than one per form — the same reason
// `src/lib/honeypot.ts` holds a single check. Two copies of this markup would
// drift, and a drifted honeypot is one a bot can tell apart.
//
// Hidden three ways, because each covers a different way a person could reach
// it: `hidden` for sight, `aria-hidden` for assistive tech, and `tabIndex={-1}`
// for the keyboard. `autoComplete="off"` keeps a password manager from filling
// it on a person's behalf, which would get a real submission discarded.

import { HONEYPOT_FIELD } from "@/lib/honeypot";

export function HoneypotField({
  /**
   * Distinguishes this instance's ids when more than one form is on a page.
   * Only the DOM id varies — the field NAME is shared on purpose.
   */
  idPrefix,
  /** Set when the form reads the value itself rather than via `<form>` state. */
  ref,
}: {
  idPrefix: string;
  ref?: React.Ref<HTMLInputElement>;
}) {
  const id = `${idPrefix}-${HONEYPOT_FIELD}`;
  return (
    <div className="hidden" aria-hidden="true">
      <label htmlFor={id}>Company Website</label>
      <input
        ref={ref}
        id={id}
        name={HONEYPOT_FIELD}
        type="text"
        tabIndex={-1}
        autoComplete="off"
        className="hidden"
      />
    </div>
  );
}
